<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaPedidos(empresaSelecionada); carregaTotens(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-select
          v-model="formasDePagamento"
          :items="formasPagamento"
          label="Formas de pagamento"
          multiple
          attach
          outlined
          dense
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 lg2 v-if="totens.length > 1">
        <v-autocomplete
          outlined
          dense
          v-model="totemSelecionado"
          :items="totens"
          item-text="descricao"
          item-value="id"
          label="Estação"
          clearable
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-btn dark @click="carregaPedidos(user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia) ? empresaSelecionada : companyobj.id)" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando pedidos..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">PEDIDOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info" style="margin: 0px">Nenhum pedido encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="body.append">
            <tr>
              <td :colspan="tabela.cabecalho.length">
                <h2 style="margin: 0 auto; text-align: center">Total: {{ campoSoma('valorConsumido').toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}</h2>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.statusPedido`]="{ item }">
            <v-chip :color="pegaCor(item.statusPedido ? item.statusPedido : '')" dark>{{ item.statusPedido ? item.statusPedido : '---' }}</v-chip>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            R$ {{ item.valor.replace('.',',') }}
          </template>
          <template v-slot:[`item.valorConsumido`]="{ item }">
            <td>R$ {{ item.valorConsumido ? item.valorConsumido : '0,00' }}</td>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <td>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="iniciarItem(item)" color="primary" :disabled="item.statusPedido != 'EM ANÁLISE'">
                  <v-icon>mdi-play-circle</v-icon>
                </v-btn>
              </template>
              <span>Iniciar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="interromperItem(item)" color="red" :disabled="item.statusPedido != 'CARREGANDO'">
                  <v-icon>mdi-close-octagon</v-icon>
                </v-btn>
              </template>
              <span>Interromper</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="deleteItem(item)" color="red">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
     <v-card-actions>
      <v-btn dark color="#00253E" :disabled="tabela.conteudo.length == 0">
        <download-csv :data="listaExportacao" encoding="UTF-8" name="Relatorio de Respostas.csv" :separator-excel="true" >
          <v-icon left size="25" color="white">cloud_download</v-icon>
          Baixar Relatório
        </download-csv>
      </v-btn>
      </v-card-actions>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar,},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      tabela: {
        cabecalho: [
          { text: 'Cliente', value: 'cliente.nome' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Status', value: 'statusPedido' },
          { text: 'Forma de Pagamento', value: 'formaPagamento' },
          { text: 'Status Pagamento', value: 'statusPagamento' },
          { text: 'Valor', value: 'valor' },
          { text: 'Valor Consumido', value: 'valorConsumido' },
          { text: 'Tempo', value: 'tempo' },
          { text: 'Data Pedido', value: 'created' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      formasPagamento: ['CARTAO','PIX','VOUCHER'],
      formasDePagamento: ['CARTAO','PIX','VOUCHER'],
      empresas: [],
      listaExportacao: [],
      totens: [],
      empresaSelecionada: '',
      totemSelecionado: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)) {
        this.carregaEmpresas()
      } else {
        this.carregaPedidos(this.companyobj.id)
        this.carregaTotens(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        let filter

        if (this.user.tipo == 'GERENTE' && this.user.franquia) {
          filter = {
            where: {"franquia": this.user.franquia},
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }
        else {
          filter = {
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }

        await axios.get(baseApiUrl + 'Empresas?filter=' + JSON.stringify(filter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaTotens(empresaId) {
        await axios.get(baseApiUrl + 'Totens?filter={"where":{"empresaId":"' + empresaId + '"}, "order":"nome ASC", "fields":{"descricao": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.totens = response.data
            
          }
        })
      },

      async carregaPedidos(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        let whereor = this.formasDePagamento.map(forma => ({ formaPagamento: forma.toString() }))

        let whereFilter = {
          "where": {
            "and": [
              {"empresaId": empresaId},
              {"or": whereor},
              {"created": {"gte": this.dataInicio + 'T' + this.horaInicio + ':00.000Z'}},
              {"created": {"lte": this.dataFim + 'T' + this.horaFim + ':00.000Z'}}
            ]
          },
          "include": ["cliente"]
        }

        if (this.totemSelecionado) {
          whereFilter.where.and.push(
            {"totemId": this.totemSelecionado}
          )
        }
        

        whereFilter = JSON.stringify(whereFilter)

        await axios.get(baseApiUrl + 'Pedidos?filter=' + whereFilter + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false  
          this.listaExportacaoRecargas(response.data)         
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora
      },

      campoSoma(chave) {
        // soma dados da chave informada
        let valorFinal = 0

        for (let pedido of this.tabela.conteudo) {
          if (pedido.statusPagamento == 'PAGO' && pedido[chave] && parseFloat(pedido[chave].replace(',','.')) > 0) {
            valorFinal += parseFloat(pedido[chave].replace(',','.'))
          }
        }
        
        return valorFinal
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async interromperItem(item) {
        let vm = this
        let resposta = confirm('Deseja realmente interromper a transação de R$ ' + item.valor + '?')

        if (resposta) {
          await axios.post(baseApiUrl + 'Pedidos/interromper?access_token=' + sessionStorage.getItem('accToken'), {"pedidoId": item.id})
          .then(response => {
            if (response.data) {
              this.carregaPedidos(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
              vm.$refs.chamaSnackbar.snack("green", "Transação interrompida!", "SUCESSO")
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Problema ao interromper transação", "DESCULPE")
          })
        }
      },

      async iniciarItem(item) {
        let vm = this
        let resposta = confirm('Deseja realmente iniciar a transação de R$ ' + item.valor + '?')

        if (resposta) {
          await axios.post(baseApiUrl + 'Pedidos/iniciar?access_token=' + sessionStorage.getItem('accToken'), {"pedidoId": item.id})
          .then(response => {
            if (response.data) {
              this.carregaPedidos(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
              vm.$refs.chamaSnackbar.snack("green", "Transação iniciada!", "SUCESSO")
            }
          })
          .catch(error => {
            vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "DESCULPE")
          })
        }
      },

      transformaData(data, formato) {
        return moment(data).format(formato);
      },

      pegaCor(status) {
        switch (status.toUpperCase()) {
          case 'INTERROMPIDO':
            // vermelho
            return '#FF0000';  
          case 'EM USO':
            // verde
            return '#28A745';
          case 'EM ANÁLISE':
            // amarelo
            return '#FFC107'; 
          case 'CARREGANDO':
            // azul
            return '#007BFF';
          case 'ENCERRADO':
            // cinza
            return '#6C757D';
          default:
            // preto
            return '#000000';
        }
      },

       listaExportacaoRecargas(lista) { 
      this.listaExportacao = []
     
      for (let i = 0; i < lista.length; i++) {
        this.listaExportacao.push({
          "Status": lista[i].statusPedido,
          "Forma de Pagamento": lista[i].formaPagamento,
          "Status Pagamento": lista[i].statusPagamento,
          "Valor": lista[i].valor,
          "Valor Consumido": lista[i].valorConsumido,          
          "Tempo": lista[i].tempo,
          "Data Pedido": lista[i].created,
          });     
       } 
      },

      async deleteItem(item) {
        let r = confirm('Realmente deseja EXCLUIR a transação de ' + item.cliente.nome + ' de R$ ' + item.valor + '?')

        if (r == true) {
          await axios.delete(baseApiUrl + 'Pedidos/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaPedidos(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
          })
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
